<svg class="svof" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 50">
  <defs>
    <style>
      .svof .svof__ants {
      stroke-dasharray: 0 0 0 0 0 0 3.186 2.23 0 0 0 0;
      fill:none;
      stroke: currentColor;
      stroke-linecap:round;
      stroke-linejoin:round;
      }
      .svof .svof__snips {
      fill:none;
      stroke: currentColor;
      stroke-linecap:round;
      stroke-linejoin:round;
      }
      .svof__blob {
      fill: currentColor;
      }
    </style>
  </defs>
  <path class="svof__ants" d="m90.658,30.158c.012-.499.024-1.048.037-1.629"/>

  <path class="svof__ants"
        d="m90.743,26.202c.078-3.921.153-8.331.165-9.59.034-3.416-1.648-7.028-9.084-6.631-4.068.217-24.508.555-39.528.65"/>

  <path class="svof__ants" d="m42.297,10.631c-.55.003-1.093.007-1.627.009"/>
  <path class="svof__ants" d="m23.24,10.605c-.522-.029-1.062-.045-1.625-.052"/>

  <path class="svof__ants"
        d="m19.388,10.559c-1.609.02-3.379.062-5.345.044-3.628-.032-6.745,2.282-6.535,7.244.269,6.371-.279,10.739.126,13.658.409,2.946,1.479,4.837,7.589,4.899,3.409.035,19.486.053,24.696.058"/>

  <path class="svof__snips"
        d="m39.014,7.616c-3.613.654-5.849,1.808-7.67,2.75-.93.481-2.268.958-3.835.445s-2.023,1.425-1.254,2.165,1.624,1.083,2.422,0-.566-2.017-.566-2.017"/>
  <path class="svof__snips"
        d="m38.895,12.612c-3.317-.497-4.835-1.494-7.882-2.97-.976-.473-1.966-.855-3.105-.627s-2.071.057-2.018-1.254,1.221-1.709,1.79-1.453.87.482,1.026,1.283c.199,1.025-.798,1.424-.798,1.424"/>

  <path class="svof__blob" d="M49,35.2l.7,1.9h-1.4l.7-1.9ZM88.5,37.2h1.4l-.7-1.9-.7,1.9ZM79.4,35.1h-.9v3.1h.9c.8,0,1.4-.6,1.4-1.6s-.6-1.6-1.4-1.6ZM44.1,35.1h-.8v1.7h.8c.6,0,.9-.3.9-.9s-.3-.9-.9-.9ZM95.1,42.6c-5.5,1.9-18.1,0-32.6,2.6-1.4.2-4.2,0-3-1.5-8.8.2-15.5,0-17.6-.5-2.1-.5-1.9-.6-2.9-1.8-.9-1.1-1.3-2.4-1.3-4.1.1-3.2.5-6,4.3-7.2,2.5-.8,6.1-.4,9-.4,3.4,0,7.3.4,12,.3h0c4.7,0,8.7.2,10.9-.2,1.8-.3,6.6.2,8.1,0,1.4-.2,4.5.4,9.8-.5,4-.7,6.7,1,7,4,.3,3,1.3,7.4-3.7,9.1ZM46.1,39.1l-1-1.6c.6-.3.9-.8.9-1.6,0-1.1-.7-1.8-1.9-1.8h-1.8v5h1v-1.4h.9l.8,1.4h1.1ZM51.4,39.1l-1.9-5h-1l-1.9,5h1l.4-1.1h2l.4,1.1h1ZM56.1,34.1h-1v3l-2.1-3h-.8v5h1v-3l2.1,3h.8v-5ZM61.5,39.1l-1.9-2.8,1.8-2.2h-1.1l-1.9,2.3v-2.3h-1v5h1v-1.3l.6-.7,1.4,2h1.2ZM65.6,38.2h-2.3v-1.2h2v-.9h-2v-1.1h2.2v-.9h-3.2v5h3.3v-.9ZM70.5,39.1l-1-1.6c.6-.3.9-.8.9-1.6,0-1.1-.7-1.8-1.9-1.8h-1.8v5h1v-1.4h.9l.8,1.4h1.1ZM74.8,37.7c0-1.8-2.5-1.2-2.5-2.1s.2-.6.8-.6.8.1,1.2.4l.3-.9c-.4-.3-.9-.4-1.5-.4-1.2,0-1.8.7-1.8,1.6,0,1.9,2.5,1.2,2.5,2.2s-.2.5-.8.5-1-.2-1.4-.5l-.3.9c.4.3,1.1.6,1.7.6,1.2,0,1.8-.7,1.8-1.6ZM81.8,36.6c0-1.5-1-2.5-2.4-2.5h-1.9v5h1.9c1.4,0,2.4-1,2.4-2.5ZM86.2,38.2h-2.3v-1.2h2v-.9h-2v-1.1h2.2v-.9h-3.2v5h3.3v-.9ZM91.6,39.1l-1.9-5h-1l-1.9,5h1l.4-1.1h2l.4,1.1h1ZM95.5,38.2h-2.1v-4.1h-1v5h3.1v-.9ZM68.5,35.1h-.8v1.7h.8c.6,0,.9-.3.9-.9s-.3-.9-.9-.9Z"/>

</svg>